import type { NablaTranscriptItem } from "@el8/scribe-client";

import type { ClientNoteTranscriptItem } from "../types";

export function createTranscriptItemFromNablaData(
  nablaTranscriptItem: NablaTranscriptItem,
  baseOffset = 0,
): ClientNoteTranscriptItem {
  const transcriptItem: ClientNoteTranscriptItem = {
    id: nablaTranscriptItem.id,
    is_final: nablaTranscriptItem.is_final,
    text: nablaTranscriptItem.text,
    source: "note1",
    speaker: nablaTranscriptItem.speaker,
    start_offset_ms: nablaTranscriptItem.start_offset_ms + baseOffset,
    end_offset_ms: nablaTranscriptItem.end_offset_ms + baseOffset,
    state: "not_sent",
  };

  return transcriptItem;
}
